import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Admin token handling (simple shared password stored in localStorage)
export const ADMIN_TOKEN_KEY = 'atf_admin_token';
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY) || '';
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

const adminHeaders = () => ({ headers: { 'X-Admin-Password': getAdminToken() } });

// ---------- Public ----------
export const submitContact = (data) => api.post('/contact', data).then((r) => r.data);
export const submitBooking = (data) => api.post('/bookings', data).then((r) => r.data);
export const submitFireside = (data) => api.post('/fireside', data).then((r) => r.data);
export const subscribe = (email) => api.post('/subscribe', { email }).then((r) => r.data);
export const getEvents = () => api.get('/events').then((r) => r.data);
export const rsvpEvent = (eventId, data) => api.post(`/events/${eventId}/rsvp`, { event_id: eventId, ...data }).then((r) => r.data);

// ---------- Payments ----------
export const createCheckout = (items, originUrl) =>
  api.post('/payments/checkout', { items, origin_url: originUrl }).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// ---------- Admin ----------
export const adminLogin = (password) => api.post('/admin/login', { password }).then((r) => r.data);
export const adminStats = () => api.get('/admin/stats', adminHeaders()).then((r) => r.data);
export const adminContacts = () => api.get('/admin/contacts', adminHeaders()).then((r) => r.data);
export const adminBookings = () => api.get('/admin/bookings', adminHeaders()).then((r) => r.data);
export const adminFireside = () => api.get('/admin/fireside', adminHeaders()).then((r) => r.data);
export const adminSubscribers = () => api.get('/admin/subscribers', adminHeaders()).then((r) => r.data);
export const adminRsvps = () => api.get('/admin/rsvps', adminHeaders()).then((r) => r.data);
export const adminOrders = () => api.get('/admin/orders', adminHeaders()).then((r) => r.data);
export const adminCreateEvent = (data) => api.post('/admin/events', data, adminHeaders()).then((r) => r.data);
export const adminUpdateEvent = (id, data) => api.put(`/admin/events/${id}`, data, adminHeaders()).then((r) => r.data);
export const adminDeleteEvent = (id) => api.delete(`/admin/events/${id}`, adminHeaders()).then((r) => r.data);
export const adminDeleteRecord = (coll, id) => api.delete(`/admin/records/${coll}/${id}`, adminHeaders()).then((r) => r.data);
export const adminDigital = () => api.get('/admin/digital', adminHeaders()).then((r) => r.data);
export const adminDigitalUpload = (slug, file, onProgress) => {
  const form = new FormData();
  form.append('slug', slug);
  form.append('file', file);
  return api.post('/admin/digital/upload', form, {
    headers: { 'X-Admin-Password': getAdminToken(), 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  }).then((r) => r.data);
};
export const adminDigitalDelete = (slug) => api.delete(`/admin/digital/${slug}`, adminHeaders()).then((r) => r.data);
export const adminRebuildStripeCatalog = () => api.post('/admin/stripe/rebuild-catalog', {}, adminHeaders()).then((r) => r.data);

export default api;
